import {
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Container,
} from '@chakra-ui/react';

export interface WhyServiceProps {
    title: string;
    subtitle?: string;
    list: {
        featuredMainNumber: string;
        featuredAddingNumber: string;
        featuredText: string;
        addingText?: string;
    }[];
}

const WhyService: React.FC<WhyServiceProps> = ({ title, subtitle, list }) => {
    return (
        <Box
            background="rgba(238, 238, 238, 1)"
            padding={'50px 15px'}
            display={'flex'}
            gap={'30px'}
            flexDir={{ base: 'column', lg: 'row' }}
        >
            <Box width={{ base: '100%', lg: 'calc((100% / 12) * 5)' }} padding="30px">
                <Text
                    textAlign="center"
                    fontSize="30px"
                    as="b"
                    className="text-wrapper"
                    align={{ base: 'center', md: 'left' }}
                    mb={{ base: '35px', md: '0' }}
                    width={'100%'}
                >
                    {title}
                </Text>
            </Box>
            <Box
                width={{ base: '100%', lg: 'calc((100% / 12) * 7)' }}
                flexDir={{ base: 'column', md: 'row' }}
                display={'flex'}
            >
                {list.map(item => {
                    return (
                        <Box
                            width={{ base: '100%', md: '50%' }}
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'center'}
                        >
                            <Text
                                fontSize={'54px'}
                                color={'rgba(26, 172, 122, 1)'}
                                fontWeight={'600'}
                            >
                                {item.featuredMainNumber}

                                <Text fontSize={'34px'} as="span">
                                    {item.featuredAddingNumber}
                                </Text>
                            </Text>
                            <Text textAlign={'center'} fontSize={'18px'} mb={'30px'}>
                                {item.featuredText}
                            </Text>
                            <Text textAlign={'center'} fontSize={'12px'}>
                                {item.addingText}
                            </Text>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default WhyService;
